const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* KWEIDER LOCAL PICKUP PHONE - START */
(() => {
  const PICKUP_TAG = 'local pickup';
  const ATTRIBUTE_NAME = 'Pickup mobile';
  const productTagsCache = new Map();
  let refreshTimer;
  let refreshRunning = false;

  const normaliseTags = (tags) => {
    if (Array.isArray(tags)) return tags.map((tag) => String(tag).trim());
    return String(tags || '').split(',').map((tag) => tag.trim()).filter(Boolean);
  };

  async function getProductTags(handle) {
    if (!handle) return [];
    if (productTagsCache.has(handle)) return productTagsCache.get(handle);
    try {
      const response = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) return [];
      const product = await response.json();
      const tags = normaliseTags(product.tags);
      productTagsCache.set(handle, tags);
      return tags;
    } catch (error) {
      return [];
    }
  }

  async function isPickupProduct(handle) {
    const tags = await getProductTags(handle);
    return tags.some((tag) => tag.toLowerCase() === PICKUP_TAG);
  }

  async function getCart() {
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) return null;
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  async function cartHasPickup(cart) {
    for (const item of (cart && cart.items) || []) {
      let handle = item.handle;
      if (!handle && item.url && item.url.includes('/products/')) {
        handle = item.url.split('/products/')[1].split('?')[0].split('/')[0];
      }
      if (await isPickupProduct(handle)) return true;
    }
    return false;
  }

  function hideElement(element) {
    if (!element || element.dataset.kweiderPickupHidden === '1') return;
    element.dataset.kweiderPickupOriginalDisplay = element.style.display || '';
    element.dataset.kweiderPickupHidden = '1';
    element.style.display = 'none';
  }

  function restoreElement(element) {
    if (!element || element.dataset.kweiderPickupHidden !== '1') return;
    element.style.display = element.dataset.kweiderPickupOriginalDisplay || '';
    delete element.dataset.kweiderPickupHidden;
    delete element.dataset.kweiderPickupOriginalDisplay;
  }

  function setCartAcceleratedCheckoutHidden(hidden) {
    document.querySelectorAll(
      '#main-cart-footer .additional-checkout-buttons, #main-cart-footer .cart__dynamic-checkout-buttons'
    ).forEach((element) => hidden ? hideElement(element) : restoreElement(element));
  }

  function setProductAcceleratedCheckoutHidden(hidden) {
    document.querySelectorAll(
      '.product-form-wrap .shopify-payment-button, .product-form-wrap shopify-accelerated-checkout'
    ).forEach((element) => hidden ? hideElement(element) : restoreElement(element));
  }

  function setPickupFreeShippingHidden(hidden) {
    document.querySelectorAll('#main-cart-footer #cart-message')
      .forEach((element) => hidden ? hideElement(element) : restoreElement(element));
  }

  function setPickupCartNote(enabled) {
    document.querySelectorAll('#main-cart-footer .tax-note').forEach((element) => {
      if (enabled) {
        if (!element.dataset.kweiderPickupOriginalHtml) {
          element.dataset.kweiderPickupOriginalHtml = element.innerHTML;
          element.dataset.kweiderPickupOriginalText = element.textContent.trim();
        }
        const originalText = element.dataset.kweiderPickupOriginalText || '';
        const taxMatch = originalText.match(/^(.*?tax[^.]*\.)/i);
        const taxPrefix = taxMatch ? `${taxMatch[1]} ` : '';
        const pickupText = `${taxPrefix}Pickup details confirmed at checkout.`;
        if (element.textContent.trim() !== pickupText) element.textContent = pickupText;
      } else if (element.dataset.kweiderPickupOriginalHtml) {
        element.innerHTML = element.dataset.kweiderPickupOriginalHtml;
        delete element.dataset.kweiderPickupOriginalHtml;
        delete element.dataset.kweiderPickupOriginalText;
      }
    });
  }

  function removePhoneField() {
    document.getElementById('kweider-pickup-mobile-wrap')?.remove();
  }

  function ensurePhoneField(cart) {
    const ctas = document.querySelector('#main-cart-footer .cart__ctas');
    if (!ctas) return;

    let wrapper = document.getElementById('kweider-pickup-mobile-wrap');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.id = 'kweider-pickup-mobile-wrap';
      wrapper.style.marginBottom = '1.5rem';
      wrapper.innerHTML = `
        <p style="margin:0 0 .8rem;font-weight:600;">Local Pickup — Kweider Acton</p>
        <label for="KweiderPickupMobile" style="display:block;margin-bottom:.6rem;font-weight:600;">
          Mobile number <span aria-hidden="true">*</span>
        </label>
        <input
          id="KweiderPickupMobile"
          type="tel"
          name="attributes[Pickup mobile]"
          form="cart"
          autocomplete="tel"
          inputmode="tel"
          required
          placeholder="07..."
          aria-describedby="KweiderPickupMobileHelp KweiderPickupMobileError"
          style="width:100%;min-height:4.8rem;padding:1rem 1.2rem;border:1px solid currentColor;background:transparent;"
        >
        <p id="KweiderPickupMobileHelp" style="margin:.6rem 0 0;font-size:1.3rem;opacity:.75;">
          Required for collection updates.
        </p>
        <p id="KweiderPickupMobileError" role="alert" style="display:none;margin:.6rem 0 0;color:#b42318;font-size:1.3rem;">
          Please enter a mobile number before checkout.
        </p>`;
      ctas.before(wrapper);
    }

    const input = wrapper.querySelector('#KweiderPickupMobile');
    if (input && !input.value && cart && cart.attributes && cart.attributes[ATTRIBUTE_NAME]) {
      input.value = cart.attributes[ATTRIBUTE_NAME];
    }
  }

  function showPhoneError() {
    const input = document.getElementById('KweiderPickupMobile');
    const error = document.getElementById('KweiderPickupMobileError');
    if (error) error.style.display = 'block';
    if (input) {
      input.setCustomValidity('Please enter a mobile number before checkout.');
      input.reportValidity();
      input.focus();
    }
  }

  function clearPhoneError() {
    const input = document.getElementById('KweiderPickupMobile');
    const error = document.getElementById('KweiderPickupMobileError');
    if (error) error.style.display = 'none';
    if (input) input.setCustomValidity('');
  }

  async function savePickupMobile(phone) {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ attributes: { [ATTRIBUTE_NAME]: phone } })
    });
    if (!response.ok) throw new Error('Unable to save pickup mobile');
  }

  async function refreshPickupUi() {
    if (refreshRunning) return;
    refreshRunning = true;
    try {
      const productMatch = window.location.pathname.match(/^\/products\/([^/?#]+)/);
      if (productMatch) {
        const handle = decodeURIComponent(productMatch[1]);
        const pickupProduct = await isPickupProduct(handle);
        document.documentElement.dataset.kweiderPickupProduct = pickupProduct ? '1' : '0';
        setProductAcceleratedCheckoutHidden(pickupProduct);
      }

      const cart = await getCart();
      if (!cart) return;
      const hasPickup = await cartHasPickup(cart);
      document.documentElement.dataset.kweiderPickupCart = hasPickup ? '1' : '0';
      setCartAcceleratedCheckoutHidden(hasPickup);
      setPickupFreeShippingHidden(hasPickup);
      setPickupCartNote(hasPickup);
      if (hasPickup) ensurePhoneField(cart);
      else removePhoneField();
    } finally {
      refreshRunning = false;
    }
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshPickupUi, 180);
  }

  document.addEventListener('input', (event) => {
    if (event.target && event.target.id === 'KweiderPickupMobile') clearPhoneError();
  });

  document.addEventListener('click', async (event) => {
    const drawerCheckout = event.target.closest('#CartDrawer-Checkout');
    if (drawerCheckout && document.documentElement.dataset.kweiderPickupCart === '1') {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.href = '/cart';
      return;
    }

    const checkout = event.target.closest('#checkout');
    if (!checkout || document.documentElement.dataset.kweiderPickupCart !== '1') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const input = document.getElementById('KweiderPickupMobile');
    const phone = input ? input.value.trim() : '';
    if (!phone) {
      showPhoneError();
      return;
    }

    clearPhoneError();
    checkout.disabled = true;
    try {
      await savePickupMobile(phone);
      window.location.href = '/checkout';
    } catch (error) {
      checkout.disabled = false;
      const errorElement = document.getElementById('KweiderPickupMobileError');
      if (errorElement) {
        errorElement.textContent = 'We could not save your mobile number. Please try again.';
        errorElement.style.display = 'block';
      }
    }
  }, true);

  document.addEventListener('DOMContentLoaded', refreshPickupUi);

  const observer = new MutationObserver(scheduleRefresh);
  if (document.documentElement) {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
/* KWEIDER LOCAL PICKUP PHONE - END */

/* KWEIDER LOCAL PICKUP POLICY - START */
(() => {
  let policyTimer;

  function nodeText(node) {
    return (node?.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function findPolicyEntries() {
    const footer = document.getElementById('main-cart-footer');
    if (!footer) return [];

    return Array.from(footer.querySelectorAll('input[type="checkbox"]'))
      .map((checkbox) => {
        let container = checkbox.closest('.shopify-app-block, .shopify-block');

        if (!container || !nodeText(container).includes('delivery & returns policy')) {
          container = null;
          let node = checkbox.parentElement;
          let depth = 0;

          while (node && node !== footer && depth < 6) {
            if (
              nodeText(node).includes('delivery & returns policy') &&
              !node.querySelector('#checkout')
            ) {
              container = node;
              break;
            }
            node = node.parentElement;
            depth += 1;
          }
        }

        if (!container || container.querySelector('#checkout')) return null;
        return { container, checkbox };
      })
      .filter(Boolean);
  }

  function applyPolicyVisibility() {
    const isPickup = document.documentElement.dataset.kweiderPickupCart === '1';

    findPolicyEntries().forEach(({ container, checkbox }) => {
      if (isPickup) {
        if (container.dataset.kweiderPickupPolicyHidden === '1') return;

        container.dataset.kweiderPickupPolicyHidden = '1';
        container.dataset.kweiderPickupPolicyDisplay = container.style.display || '';
        checkbox.dataset.kweiderPickupPolicyRequired = checkbox.required ? '1' : '0';
        checkbox.dataset.kweiderPickupPolicyDisabled = checkbox.disabled ? '1' : '0';

        checkbox.required = false;
        checkbox.disabled = true;
        container.style.display = 'none';
      } else if (container.dataset.kweiderPickupPolicyHidden === '1') {
        container.style.display = container.dataset.kweiderPickupPolicyDisplay || '';
        checkbox.required = checkbox.dataset.kweiderPickupPolicyRequired === '1';
        checkbox.disabled = checkbox.dataset.kweiderPickupPolicyDisabled === '1';

        delete checkbox.dataset.kweiderPickupPolicyRequired;
        delete checkbox.dataset.kweiderPickupPolicyDisabled;
        delete container.dataset.kweiderPickupPolicyHidden;
        delete container.dataset.kweiderPickupPolicyDisplay;
      }
    });
  }

  function schedulePolicyApply() {
    window.clearTimeout(policyTimer);
    policyTimer = window.setTimeout(applyPolicyVisibility, 120);
  }

  document.addEventListener('DOMContentLoaded', () => {
    schedulePolicyApply();

    const footer = document.getElementById('main-cart-footer');
    if (footer) {
      new MutationObserver(schedulePolicyApply).observe(footer, {
        childList: true,
        subtree: true
      });
    }
  });

  new MutationObserver(schedulePolicyApply).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-kweider-pickup-cart']
  });

  setTimeout(schedulePolicyApply, 500);
})();
/* KWEIDER LOCAL PICKUP POLICY - END */
